module.exports = __webpack_public_path__ + "img/phone-3.2d9f9123.jpg";